export const displayFormaCards = ({
  has_non_hsa_pretax_accounts,
  is_unit_forma_card_enabled,
  is_credit_card_enabled,
}: {
  has_non_hsa_pretax_accounts: boolean;
  is_unit_forma_card_enabled: boolean;
  is_credit_card_enabled: boolean;
}) =>
  (has_non_hsa_pretax_accounts || is_unit_forma_card_enabled) &&
  is_credit_card_enabled;
